import { useGetEntity } from "../api/orders/hooks";
import { useStore } from "../store";

export const useEntity = () => {
  const { userManager } = useStore();
  const { data: entity } = useGetEntity(
    userManager.entity,
    !!userManager.entity
  );

  const showSectors = entity?.isSectorsOnTheKitchenTotem;
  const showObservations = entity?.showObservations;
  const allowPurchaseWithNegativeBalance =
    entity?.allowPurchaseWithNegativeBalance;
  const allowStudentCardMachinePurchase =
    entity?.allowStudentCardMachinePurchase;
  const isPixEnabledOnTotem = entity?.isPixEnabledOnTotem ?? true;

  return {
    entity,
    showSectors,
    showObservations,
    allowPurchaseWithNegativeBalance,
    allowStudentCardMachinePurchase,
    isPixEnabledOnTotem,
  };
};
